export default __webpack_public_path__ + "static/tui-logo.5b151014.svg";